import { init } from '@airwallex/components-sdk';

type Sdk = Awaited<ReturnType<typeof init>>;
const sdks: Partial<Record<'demo' | 'prod', Promise<Sdk>>> = {};

/** One SDK instance per environment; `init` must not run twice for the same env. */
export function getAirwallexBillingSdk(env: 'demo' | 'prod'): Promise<Sdk> {
  sdks[env] ??= init({
    env,
    enabledElements: ['billing'],
    locale: 'en',
  });
  return sdks[env]!;
}

/** Test seam: forget cached SDK promises. */
export function resetAirwallexBillingSdk(): void {
  delete sdks.demo;
  delete sdks.prod;
}
